const loginError = 'There is a problem logging in';

const logoutError = 'There is a problem logging out';

const tokenError = 'There is a problem getting the access token';

export const msalErrorMessages = {
  loginError,
  logoutError,
  tokenError,
};
